import Vue from 'vue';
import Vuex from 'vuex';
// import persist from 'vuex-localstorage';
import persist from 'vuex-persistedstate';

import * as AuthModule from './Auth';
import * as PolicyModule from './Policy';
import * as PaymentModule from './Payment';
import * as OrganizationsModule from './Organizations';
import * as UserModule from './User';
import * as OrgAdminModule from './OrgAdmin';
import * as RiskResourcesModule from './RiskResources';
import * as NotificationsModule from './Notifications';
import * as ClaimsFormModule from './ClaimsForm';

import BrandModule from './Brand';
import LatestNewsModule from './LatestNews';
import MiscModule from './Misc';
import RegistrationModule from './Registration';

Vue.use(Vuex);

export default new Vuex.Store<any>({
	modules: {
		Auth: {
			namespaced: true,
			...AuthModule,
		},
		Policy: {
			namespaced: true,
			...PolicyModule,
		},
		// @ts-ignore
		Payment: {
			namespaced: true,
			...PaymentModule,
		},
		Brand: {
			namespaced: true,
			...BrandModule,
		},
		LatestNews: {
			namespaced: true,
			...LatestNewsModule,
		},
		Misc: {
			namespaced: true,
			...MiscModule,
		},
		Organizations: {
			namespaced: true,
			...OrganizationsModule,
		},
		Users: {
			namespaced: true,
			...UserModule,
		},
		OrgAdmin: {
			namespaced: true,
			...OrgAdminModule,
		},
		RiskResources: {
			namespaced: true,
			...RiskResourcesModule,
		},
		Registration: {
			namespaced: true,
			...RegistrationModule,
		},
		Notifications: {
			namespaced: true,
			...NotificationsModule,
		},
		ClaimsForm: {
			namespaced: true,
			...ClaimsFormModule,
		},
	},
});
